const heapIsReady = callback => {
  if (typeof window !== 'undefined') {
    const eventInterval = setInterval(() => {
      if ((window as any)?.heap) {
        callback()
        clearInterval(eventInterval)
      }
    }, 500)
    setTimeout(() => {
      clearInterval(eventInterval)
    }, 30000)
  }
}

const heap = {
  // use for fire events
  track: (eventName: string, properties: Record<string, any>) =>
    heapIsReady(() => (window as any)?.heap?.track(eventName, properties)),
  // use to set or reset userId
  identify: (id: string | number) =>
    heapIsReady(() => (window as any)?.heap?.identify(id)),
  resetIdentity: () =>
    heapIsReady(() => (window as any)?.heap?.resetIdentity()),
  // use to set or remove user additional information like phone number, name and etc
  addUserProperties: (userProperties: Record<string, any>) =>
    heapIsReady(() => (window as any)?.heap?.addUserProperties(userProperties)),
  removeUserProperties: (propertyName: string) =>
    heapIsReady(() =>
      (window as any)?.heap?.removeUserProperties(propertyName),
    ),
  // use to set or remove some or completely clear properties of an event
  setEventProperties: (eventProperties: Record<string, any>) =>
    heapIsReady(() =>
      (window as any)?.heap?.setEventProperties(eventProperties),
    ),
  removeEventProperty: (propertyName: string) =>
    heapIsReady(() => (window as any)?.heap?.removeEventProperty(propertyName)),
  clearEventProperties: () =>
    heapIsReady(() => (window as any)?.heap?.clearEventProperties()),
  // use to reload heap in window
  reload: () => heapIsReady(() => (window as any)?.heap?.reload()),
}

export default heap
